<script lang="ts">
	import type { HTMLAttributes } from "svelte/elements";
	import Formatted from "./common/Formatted.svelte";

	const all: Omit<HTMLAttributes<HTMLDivElement>, "children"> = $props();
</script>

<div
	{...all}
	class={["font-medium text-center tracking-[0.02em] text-2xs/none md:text-base/tight mt-1 xl:text-left", all.class]}
>
	<Formatted
		text="
			Tato stránka je chráněna službou reCAPTCHA a uplatňují se nl[[]]
			l[https://policies.google.com/privacy][[Zásady ochrany soukromí]]
			a l[https://policies.google.com/terms][[Smluvní podmínky]] společnosti Google.
		"
	/>
</div>
